import React, { Component, Fragment } from 'react';
import Sidebar from "../navigation/Sidebar";
import Splinechart from "../charts/Splinechart";
import { Link } from "react-router-dom";
import Rest from "../../services/Rest";
import { withRouter } from "react-router-dom";
import ModalSim from "../ModalSim";
const initialState = {
    error: false,
    messageError: "",
    success: false,
    successMessage: "",
    detalle: [{
        Dongles: [],
        Estado: "",
        IP: "",
        Mensajes: 0,
        Nombre: "",
        cantidadDongles: 0,
        Proceso:[],
        ProcesoMaster:[]
    }],
    showLoader: false,
    modalOptions: {
        show: "",
        numero: "",
        company: "",
        imei: "",
        idServidor: 0,
        indexDongle: 0
    },
    datatotestsim: {},
    socket: {
        show: ""
    }
}
class Serverdetail extends Component {

    constructor(props) {
        super(props)
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
        this.id_servidor = this.props.match.params.id;
        this.endpointMaster="http://srv1.smsrapidos.com/api/v1/servidores";
    }

    state = { ...initialState }

    componentDidMount() {
        this.obtenerDetalle();
    }

    obtenerDetalle() {
        this.setState({
            showLoader: true
        })
        this.Rest.get("esclavos/" + this.id_servidor, this.datauser)
            .then(resp => {
                if (resp.error) {
                    this.setState({
                        error: true,
                        messageError: resp.error,
                        showLoader: false
                    })
                }
                else {

                    this.setState({
                        detalle: resp,
                        showLoader: false
                    })

                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "No se pudo obtener el detalle del servidor",
                    showLoader: false
                })
            })
    }

    actualizar() {
        this.setState({
            showLoader: false,
            error: false,
            messageError: ""
        })
        this.obtenerDetalle()
    }

    openModal(imei, telefono,company, i) {
        this.setState({
            modalOptions: {
                show: "show",
                numero: telefono,
                imei: imei,
                company: company,
                idServidor: this.id_servidor,
                indexDongle: i
            }
        })
    }

    closeModal = e => {
        this.setState({
            modalOptions: {
                show: "",
                numero: "",
                idServidor: 0
            }
        })
    }

    setNumberSim = e => {
        this.setState({
            modalOptions: {
                ...this.state.modalOptions,
                [e.target.name]: e.target.value
            }
        })
    }

    saveNumberSim = e => {
        e.persist();
        this.setState({
            showLoader: true,
            modalOptions: {
                ...this.state.modalOptions,
                show: ""
            }

        })
        this.Rest.post(this.state.modalOptions, 'adddonglenumber', 'sim', this.datauser)
            .then(response => {
                if (response.error.Status === 200) {
                    this.setState({
                        error: false,
                        messageError: "",
                        success: true,
                        successMessage: response.error.Data.Database
                    }, () => {
                        //console.log(this.state.modalOptions.indexDongle)
                        this.state.detalle.Dongles[this.state.modalOptions.indexDongle].Number = response.error.Data.Modificado.NUMBER
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem("ls");
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            success: false,
                            error: true,
                            messageError: response.message
                        })
                    }
                }
                this.setState({
                    showLoader: false
                })
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Ocurrió un error al asignar este número",
                    showLoader: false
                })
            })
    }

    searchDongles() {
        this.setState({
            showLoader: true
        })
        this.Rest.get('searchdongles/' + this.id_servidor, this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.state.detalle.Dongles = response.dongles
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem("ls");
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            success: false,
                            error: true,
                            messageError: response.message
                        })
                    }
                }
                this.setState({
                    showLoader: false
                })
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Ocurrió un error al intentar buscar dongles",
                    showLoader: false
                })
            })
    }

    dismiss() {
        this.setState({
            error: false,
            messageError: "",
            success: false,
            successMessage: ""
        })
    }

    realizarPrueba(imei) {
        this.setState({
            showLoader: true,
            datatotestsim: {
                imei: imei,
                ip: this.state.detalle.IP
            }
        }, () => {

            this.Rest.post(this.state.datatotestsim, 'testsim', 'imei', this.datauser)
                .then(response => {
                    if (response.Status === 200) {
                        if (response.Test) {

                            this.setState({
                                error: false,
                                messageError: "",
                                successMessage: "Prueba realizada con éxito",
                                success: true
                            })
                        }
                        else {
                            this.setState({
                                success: false,
                                successMessage: "",
                                error: true,
                                messageError: "Fallo realizar la prueba del sim"
                            })
                        }
                    }
                    else {

                        this.setState({
                            successMessage: "",
                            success: false,
                            error: true,
                            messageError: "Fallo realizar la prueba del sim"
                        })


                    }
                    this.setState({
                        showLoader: false
                    })
                })
                .catch(err => {
                    this.setState({
                        error: true,
                        messageError: "Ocurrió un error al intentar realizar la prueba del sim",
                        showLoader: false
                    })
                })
        })
    }


    toggleProcesos(iniciar){
        if(iniciar){
            this.Rest.get("StartProcess/" + this.id_servidor, this.datauser)
            .then(resp=>{
                if(resp.Status===200){
                    this.setState({
                        detalle:{
                            ...this.state.detalle,
                            Proceso:{
                                Status:resp.Status,
                                Data:resp.Data,
                                btnClass:resp.btnClass,
                                iniciar:resp.iniciar,
                                Titulo:resp.Titulo
                            }
                        },
                        success:true,
                        successMessage:"Procesos iniciados correctamente"
                    })
                }
                else{
                    this.setState({
                        successMessage:"",
                        success:false,
                        error:true,
                        messageError:resp.Data
                    })
                }
            })
            .catch(err=>{
                this.setState({
                    successMessage:"",
                    success:false,
                    error:true,
                    messageError:JSON.stringify(err)
                })
            })
        }
        else{
            this.Rest.get("StopProcess/" + this.id_servidor, this.datauser)
            .then(resp=>{
                if(resp.Status===200){
                    this.setState({
                        detalle:{
                            ...this.state.detalle,
                            Proceso:{
                                Status:resp.Status,
                                Data:resp.Data,
                                btnClass:resp.btnClass,
                                iniciar:resp.iniciar,
                                Titulo:resp.Titulo
                            }
                        },
                        success:true,
                        successMessage:"Procesos detenidos correctamente"
                    })
                }
                else{
                    this.setState({
                        successMessage:"",
                        success:false,
                        error:true,
                        messageError:resp.Data
                    })
                }
            })
            .catch(err=>{
                this.setState({
                    successMessage:"",
                    success:false,
                    error:true,
                    messageError:JSON.stringify(err)
                })
            })
        }
    }

    toggleProcesosMaster(iniciar){
        if(iniciar){
            this.Rest.get(this.endpointMaster+"/iniciarProcesosMaestro" , this.datauser)
                .then(resp=>{
                    if(resp.Status===200){
                        this.setState({
                            detalle:{
                                ...this.state.detalle,
                                ProcesoMaster:{
                                    Status:200,
                                    Data:"",
                                    btnClass:"btn btn-success",
                                    iniciar: "Procesos Iniciados",
                                    Titulo: "Procesos del Maestro"
                                }
                            },
                            success:true,
                            successMessage:"Procesos iniciados correctamente"
                        })
                    }
                    else{
                        this.setState({
                            successMessage:"",
                            success:false,
                            error:true,
                            messageError:resp.Data
                        })
                    }
                })
                .catch(err=>{
                    this.setState({
                        successMessage:"",
                        success:false,
                        error:true,
                        messageError:JSON.stringify(err)
                    })
                })
        }
        else{
            this.Rest.get(this.endpointMaster+"/detenerProcesosMaestro" + this.id_servidor, this.datauser)
                .then(resp=>{
                    if(resp.Status===200){
                        this.setState({
                            detalle:{
                                ...this.state.detalle,
                                ProcesoMaster:{
                                    Status: true,
                                    Data: "",
                                    btnClass:"btn btn-danger",
                                    iniciar: "Procesos detenidos",
                                    Titulo: "Procesos del Maestro"
                                }
                            },
                            success:true,
                            successMessage:"Procesos detenidos correctamente"
                        })
                    }
                    else{
                        this.setState({
                            successMessage:"",
                            success:false,
                            error:true,
                            messageError:resp.Data
                        })
                    }
                })
                .catch(err=>{
                    this.setState({
                        successMessage:"",
                        success:false,
                        error:true,
                        messageError:JSON.stringify(err)
                    })
                })
        }
    }


    render() {
        const { error, messageError, success, successMessage, detalle, showLoader } = this.state;
        return (
            <Fragment>
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="d-flex">
                                        <div className="mr-auto">
                                            <h4 className="mb-center">Detalle del servidor</h4>
                                        </div>
                                        <div>
                                            <button type="button" className="btn btn-primary" onClick={() => this.actualizar()}>Refrescar</button>
                                            <button type="button" className="btn btn-info ml-3" onClick={() => this.searchDongles()}>Buscar dongles</button>
                                            <Link to="/servidores" className="btn btn-secondary ml-3">&laquo; Volver</Link>
                                        </div>
                                    </div>
                                    {error ?
                                        <div className="alert alert-danger alert-float">
                                            <button type="button" className="close" onClick={() => this.dismiss()}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <b>{messageError}</b>
                                        </div> : null}
                                    {success ?
                                        <div className="alert alert-success alert-float">
                                            <button type="button" className="close" onClick={() => this.dismiss()}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <b>{successMessage}</b>
                                        </div> : null}
                                    <div className="detalle-servidor-wrapper container">
                                        <div className="row selector-sim">
                                            <select className="form-control" name="selector_sim" id="selector_sim">
                                                {typeof detalle.Dongles !== "undefined" ?
                                                    detalle.Dongles.map((objValue, index) => (
                                                        <option value={objValue.Number} key={index}>{objValue.Number}</option>
                                                    ))
                                                    : <option>El servidor no tiene sims</option>}
                                            </select>
                                        </div>
                                        <div className="row">
                                            <div className="detalle-servidor-sidebar col-md-3">
                                                <ul className="list-unstyled">
                                                    <li className="li-card-item">
                                                        <p className="detalle-servidor-titulos">
                                                            <strong>Mensajes en cola</strong>
                                                        </p>
                                                        <p className="padding-lr">{detalle.Mensajes}</p>
                                                    </li>
                                                    <li className="li-card-item">
                                                        <p className="detalle-servidor-titulos">
                                                            <strong>Nombre del servidor</strong>
                                                        </p>
                                                        <p className="padding-lr">{detalle.Nombre}</p>
                                                    </li>
                                                    <li className="li-card-item">
                                                        <p className="detalle-servidor-titulos">
                                                            <strong>Mensajes</strong>
                                                        </p>
                                                        <p className="padding-lr">{detalle.Mensajes}</p>
                                                    </li>

                                                    <li className="li-card-item">
                                                        <p className="detalle-servidor-titulos">
                                                            <strong>Estatus del servidor</strong>
                                                        </p>

                                                        <p className="padding-lr text-center">
                                                            <i className={"fas fa-circle " + detalle.Estado === "Ready" ? "text-success":"text-danger"}></i>{detalle.Estado==="Ready"?"Servidor listo":"Fallo del servidor"}
                                                        </p>
                                                    </li>
                                                    <li className="li-card-item">
                                                        <p className="detalle-servidor-titulos">
                                                            <b>IP</b>
                                                        </p>
                                                        <p className="padding-lr">{detalle.IP}</p>
                                                    </li>
                                                    <li className="li-card-item">
                                                        <p className="detalle-servidor-titulos">
                                                            <b>Estado de procesos</b>
                                                        </p>
                                                        <p className="text-center">{detalle.Proceso && detalle.Proceso.Titulo}</p>
                                                        <p className="padding-lr">
                                                        {detalle.Proceso && 
                                                        <button className={detalle.Proceso.btnClass} onClick={()=>this.toggleProcesos(detalle.Proceso.iniciar)}>{detalle.Proceso.Data}</button>
                                                        }
                                                        </p>
                                                        <p className="text-center">{detalle.ProcesoMaster && detalle.ProcesoMaster.Titulo}</p>
                                                        <p className="padding-lr">
                                                            {detalle.ProcesoMaster &&
                                                            <button className={detalle.ProcesoMaster.btnClass} onClick={()=>this.toggleProcesosMaster(detalle.ProcesoMaster.iniciar)}>{detalle.Proceso.Data}</button>
                                                            }
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="detalle-servidor-content col-md-9">
                                                <div className="detalle-servidor-botones row">
                                                    <ul className="list-unstyled sims">
                                                        {typeof detalle.Dongles !== "undefined" ?
                                                            detalle.Dongles.map((objValue, index) => (
                                                                <li key={index} className="c-imei">
                                                                    <div className="header-c-imei">{"Dongle " + index}</div>
                                                                    <div className="p-1">
                                                                        <p>IMEI: {objValue.IMEI}</p>
                                                                        <p onClick={() => this.openModal(objValue.IMEI, objValue.Number,objValue.company, index)}>Tel: {objValue.Number} <span><i className="fas fa-pencil-alt"></i></span></p>
                                                                        <p>Compañia: {objValue.company === "telcel"?"Telcel":"AT&T"}</p>
                                                                        <p>Status: {objValue.Estado === "Ready" ? <button className="btn btn-success disabled btn-sm">Activo</button> : <button className="btn btn-sm btn-danger disabled">Inactivo</button>} </p>
                                                                        <button className="btn btn-secondary" onClick={() => this.realizarPrueba(objValue.IMEI)}>Realizar prueba</button>
                                                                    </div>
                                                                </li>
                                                            ))
                                                            : <li className="container-warning">
                                                                <div className="alert alert-warning">El servidor no tiene sims</div>
                                                              </li>}
                                                    </ul>
                                                </div>
                                                <div className="detalle-servidor-dash">
                                                    {showLoader && <span className="box-server"><i>Obteniendo información...</i> <i className="fas fa-spinner fa-spin"></i></span>}
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <ModalSim
                    options={this.state.modalOptions}
                    closeModal={() => this.closeModal}
                    setNumberSim={() => this.setNumberSim}
                    saveNumberSim={() => this.saveNumberSim}
                />


            </Fragment>
        );
    }
}

export default withRouter(Serverdetail);


// WEBPACK FOOTER //
// ./src/components/servers/Serverdetail.js